import script from "./PanelBanners.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelBanners.vue?vue&type=script&setup=true&lang=js"

import "./PanelBanners.vue?vue&type=style&index=0&id=2f197d43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f197d43"]])

export default __exports__